import { Box, ColorUnion, Icon, Tag, Text } from '@factorialco/deprecated-design-system'
import { PayrollSendToBookkeeperIncidenceFragment } from 'generated/resources/graphql'

import Tooltip from 'modules/core/components/Tooltip'
import i18n from 'modules/core/lib/i18n'

interface Props {
  incidences: PayrollSendToBookkeeperIncidenceFragment[]
}

interface StatCardProps {
  title: string
  tooltip: string
  count: number
  color: ColorUnion
}

const StatCard = ({ title, tooltip, count, color }: StatCardProps) => {
  return (
    <Box minHeight="full" flexGrow>
      <Box
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        borderRadius={{
          all: 'abs012',
        }}
        paddingY="s16"
        paddingX="s24"
        gap="s8"
      >
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
          <Tag size="normal" type={color} inline>
            <Text.Normal size="200" whiteSpace="nowrap" weight="medium" color="grey1000">
              {title}
            </Text.Normal>
          </Tag>
          <Tooltip.Alt label={tooltip} attachment="bottom center">
            <Icon.Medium icon="question-circle-line" />
          </Tooltip.Alt>
        </Box>
        <Text.Header1 weight="semibold" color="grey1000">
          {count}
        </Text.Header1>
      </Box>
    </Box>
  )
}

const Stats = ({ incidences }: Props) => {
  const validIncidencesCount =
    incidences.filter((incidence) => incidence.ruleEvaluation?.validity === 'valid').length ?? 0

  const incidencesWithWarningCount =
    incidences.filter((incidence) => incidence.ruleEvaluation?.validity === 'warning').length ?? 0

  const blockedIncidencesCount =
    incidences.filter((incidence) => incidence.ruleEvaluation?.validity === 'blocked').length ?? 0

  return (
    <Box flexDirection="row" gap="s12" maxHeight="fit-content">
      <StatCard
        title={i18n.t(
          'bookkeepers.incidence.bulk_status_changes.send_to_bookkeeper.stats.blocked.title'
        )}
        tooltip={i18n.t(
          'bookkeepers.incidence.bulk_status_changes.send_to_bookkeeper.stats.blocked.description'
        )}
        count={blockedIncidencesCount}
        color="radical"
      />
      <StatCard
        title={i18n.t(
          'bookkeepers.incidence.bulk_status_changes.send_to_bookkeeper.stats.warning.title'
        )}
        tooltip={i18n.t(
          'bookkeepers.incidence.bulk_status_changes.send_to_bookkeeper.stats.warning.description'
        )}
        count={incidencesWithWarningCount}
        color="champagne"
      />
      <StatCard
        title={i18n.t(
          'bookkeepers.incidence.bulk_status_changes.send_to_bookkeeper.stats.valid.title'
        )}
        tooltip={i18n.t(
          'bookkeepers.incidence.bulk_status_changes.send_to_bookkeeper.stats.valid.description'
        )}
        count={validIncidencesCount}
        color="correct"
      />
    </Box>
  )
}

export default Stats
